"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCheckboxPropertySelector = createCheckboxPropertySelector;
const react_1 = __importDefault(require("react"));
const property_1 = require("@promaster-sdk/property");
const defaultCheckboxContainer = (props) => (react_1.default.createElement("div", Object.assign({}, props, { style: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        cursor: "pointer"
        // img {
        //   max-width: 100px;
        //   max-height: 100px;
        // }
    } })));
const defaultCheckbox = (props) => (react_1.default.createElement("div", Object.assign({}, props, { style: {
        marginTop: "6px",
        position: "relative",
        backgroundColor: "#ccc",
        width: "22px",
        height: "22px",
        background: props.checked ? "red" : "green"
        // &:after {
        //   display: ${(p: CheckboxProps) => (p.checked ? "initial" : "none")};
        //   position: absolute;
        //   top: 1px;
        //   left: 7px;
        //   content: '';
        //   border-right: 3px solid black;
        //   border-bottom: 3px solid black;
        //   width: 6px;
        //   height: 12px;
        //   transform: rotate(45deg);
        // }
    } })));
function createCheckboxPropertySelector({ CheckboxContainer = defaultCheckboxContainer, Checkbox = defaultCheckbox }) {
    return function CheckboxPropertySelector({ propertyName, propertyValueSet, valueItems, showCodes, onValueChange, locked, comparer }) {
        const value = property_1.PropertyValueSet.getValue(propertyName, propertyValueSet);
        if (!valueItems || valueItems.length !== 2) {
            return react_1.default.createElement("div", null);
        }
        const falseValue = valueItems[0];
        const trueValue = valueItems[1];
        if (!falseValue.value || !trueValue.value) {
            return react_1.default.createElement("div", null);
        }
        const checked = property_1.PropertyValue.equals(trueValue.value, value, comparer);
        const nextValue = checked ? falseValue.value : trueValue.value;
        return (react_1.default.createElement(CheckboxContainer, { locked: locked, checked: checked, onClick: () => onValueChange(nextValue) },
            trueValue.image && react_1.default.createElement("img", { src: trueValue.image }),
            react_1.default.createElement("div", null, _getItemLabel(trueValue, showCodes)),
            react_1.default.createElement(Checkbox, { locked: locked, checked: checked })));
    };
}
function _getItemLabel(valueItem, showCodes) {
    if (valueItem.value === undefined || valueItem.value === null) {
        return "";
    }
    return (valueItem.text +
        (showCodes ? ` (${property_1.PropertyValue.toString(valueItem.value)}) ` : ""));
}
//# sourceMappingURL=checkbox-property-selector.js.map